import ActionTypes from 'store/actionTypes/admin/documentationFileLists';
import Tags from 'types/Tags';

export type List = 'main';

type SetPage = (
  list: List,
  page: number,
) => { type: ActionTypes; value: number };
export const setPage: SetPage = (list, page) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_PAGE,
        value: page,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_PAGE,
        value: 0,
      };
  }
};

type SetSearch = (
  list: List,
  search: string,
) => { type: ActionTypes; value: string };
export const setSearch: SetSearch = (list, search) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_SEARCH,
        value: search,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_SEARCH,
        value: '',
      };
  }
};

type SetTags = <TagColumnNames extends string>(
  list: List,
  tags: Tags<TagColumnNames>,
) => { type: ActionTypes; value: Tags<TagColumnNames> };
export const setTags: SetTags = (list, tags) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_TAGS,
        value: tags,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_TAGS,
        value: tags,
      };
  }
};

type SetActiveColumns = <Columns extends { [key: string]: boolean }>(
  list: List,
  activeColumns: Columns,
) => { type: ActionTypes; value: Columns };
export const setActiveColumns: SetActiveColumns = (list, activeColumns) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
  }
};

type SetTake = (
  list: List,
  take: number,
) => { type: ActionTypes; value: number };
export const setTake: SetTake = (list, take) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_TAKE,
        value: take,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_TAKE,
        value: 30,
      };
  }
};
